module.exports = __webpack_public_path__ + "img/qita.cdbbe54c.jpg";